import {observer, useLocalStore} from '@api'
import {MenuDivider} from '@blueprintjs/core'
import {CardSizeSliderContextMenuItem, CardSpacingSliderCatalog, CardSpacingSliderContextMenuItem, ContextMenuItem, ContextMenuItemProps, ImageRatiosMenuItem, ImageSourcesMenuItem, PresetCardViewsCurrentWorkspaceMenuItem, ShowFieldTitlesMenuItem, SurfaceNestedFieldsToggleMenuItem, useStores, useVipLocalStore, VipLocalStore} from '@modules'
import {useCatalog} from '@stores'
import {icons} from '@stores/ui'
import {action, computed} from 'mobx'
import React, { Fragment } from 'react'

class CatalogViewModeContextMenuItemStore extends VipLocalStore {
  @computed get currentIcon() {
    const {viewMode, catalog} = this

    return catalog.isShowingClientPDF ? icons.pdf : viewMode === 'card' ? icons.card : viewMode === 'table' ? icons.table : icons.blank
  }

  @computed get currentText() {
    const {strings, catalog} = this
    return catalog.isShowingClientPDF ? 'PDF View' : strings.catalogViewModeFor(this.viewMode)
  }

  get viewMode() { return this.catalog.settings.viewMode }
}

export const CatalogViewModeContextMenuItem = observer<{ children?: React.ReactNode } & ContextMenuItemProps>(function CatalogViewMode({children, ...props}) {
  const {catalog: {settings, onSwitchToCardView, onSwitchToGridView, isShowingClientPDF, features: {actionButtons}}, currentIcon, currentText, viewMode} = useVipLocalStore((ws) => new CatalogViewModeContextMenuItemStore(ws))

  return (
    <Fragment>
      <ContextMenuItem {...props} icon={currentIcon} text={currentText}>
        {settings.viewMode === 'card'
         && <Fragment>
	         <CardSpacingSliderContextMenuItem />
             <CardSizeSliderContextMenuItem/>
	         <PresetCardViewsCurrentWorkspaceMenuItem dividerBefore dividerAfter/>
           {settings.showCardLabels && <Fragment>
			   <CollapseAllCardFieldsMenuItem/>
			   <ExpandAllCardFieldsMenuItem/>
			   <MenuDivider/>
		   </Fragment>}

			 <ShowFieldTitlesMenuItem/>
	         <SurfaceNestedFieldsToggleMenuItem/>
	         <ToggleAutoLoadMoreCardsMenuItem/>
           <MenuDivider/>
           {/*<CatalogColumnsSliderContextMenuItem dividerBefore dividerAfter/>*/}
		 </Fragment> /*:
       <CatalogColumnsSliderContextMenuItem dividerAfter/>*/
        }
        {/*<ManageFieldsContextMenuItem />*/}

        <ImageSourcesMenuItem/>
        <ImageRatiosMenuItem/>
        <MenuDivider/>

        {/*<ContextMenuItem text={<Slider marks={true} min={100} max={750} step={25} />} />}*/}
        {/*<MenuDivider/>*/}
        <ContextMenuItem icon={icons.card} disabled={!isShowingClientPDF && viewMode === 'card'} text={'Switch to Card View...'} onClick={onSwitchToCardView}/>
        {actionButtons?.tableView === true && <ContextMenuItem icon={icons.table} disabled={!isShowingClientPDF && viewMode === 'table'} text={'Switch to Table View...'} onClick={onSwitchToGridView}/>}
        <SwitchToPdfMenuItem />
        {children}
      </ContextMenuItem>
    </Fragment>)
});

export const SwitchToPdfMenuItem = observer(function SwitchToPdfMenuItem() {
  const {catalog: {isShowingClientPDF, pdfCatalogStore: {client_onTogglePdfView}, onSwitchToPdfView}} = useStores()

  return (<ContextMenuItem icon={icons.pdf} active={isShowingClientPDF} text={'PDF View...'} onClick={client_onTogglePdfView}/>)
})

const ToggleAutoLoadMoreCardsMenuItem = observer(function ToggleAutoLoadMoreCardsMenuItem() {
    const {settings, settings:{autoLoadMoreCards}} = useCatalog()

    return (<ContextMenuItem icon={autoLoadMoreCards ? 'tick' : 'blank'} onClick={() => settings.autoLoadMoreCards = !autoLoadMoreCards} text='Load More Cards Automatically'/>)
})
const CollapseAllCardFieldsMenuItem = observer(function CollapseAllCardFieldsMenuItem() {
  const {strings, cv} = useCatalog()
  return (<ContextMenuItem icon='double-chevron-up' text={`${strings.collapseAll} Card Fields`} onClick={cv.collapseAllVisibleCardFields}/>)
})

const ExpandAllCardFieldsMenuItem = observer(function CollapseAllCardFieldsMenuItem() {
  const {strings, cv} = useCatalog()
  return (<ContextMenuItem icon='double-chevron-down' text={`${strings.expandAll} Card Fields`} onClick={cv.expandAllVisibleCardFields}/>)
})



// WEBPACK FOOTER //
// ./src/modules/contextMenus/menus/CatalogViewModeContextMenuItem.tsx